import React from "react";
import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";

import IfUserIs from "@/components/if-user-is";
import Notifications from "@/components/notifications/notifications";
import UserToolbar from "@/components/user-toolbar";

import styles from "./header.module.scss";

export const Header = () => {
  return (
    <div className={styles.header}>
      <Link href="/" className="hover:no-underline">
        <h1 className="mr-4 mb-0 text-black">The Animator</h1>
      </Link>
      <nav className={styles["main-nav"]}>
        <Link href="/gallery">Gallery</Link>
        <Link href="/editor">Editor</Link>
        <Link href="/my-studio">My Studio</Link>
        <Link href="/community">Community</Link>
      </nav>
      <div className="flex flex-row justify-between space-x-2 items-center">
        <Link href="/search">
          <FontAwesomeIcon icon={faSearch} />
        </Link>
        <IfUserIs signedIn>
          <Notifications />
        </IfUserIs>
        <UserToolbar />
      </div>
    </div>
  );
};
